<form [formGroup]="form.formGroup">

  <p-tabs value="0" (valueChange)="selectedTabChange.emit($event)">
    <p-tablist>
      <p-tab value="0">Operation Details</p-tab>
      @if (showLandingString && showRiser) {
        <p-tab value="1">Landing String
          @if (landingStringMissing) {
            <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Landing string not specified."></i>
          }
        </p-tab>
      }
      @if (showRiser && isInside) {
        <p-tab value="2">Riser
          @if (form.formGroup.controls?.insideDiameter.invalid || form.formGroup.controls?.outsideDiameter.invalid) {
            <i class="validation-error pi pi-exclamation-circle pl-1" pTooltip="Operation not saved, some required inputs not specified."></i>
          }
        </p-tab>
      }
    </p-tablist>

    <p-tabpanels class="pl-4 pr-2">
      <p-tabpanel class="mt-2" value="0">
        <div class="pb-3 flex flex-col">
          <label for="pressure">Pressure Location
            @if (isAnnulus) {
              <i pTooltip="Annular pressure specified overrides Annulus Contents for this operation only" class="pi pi-info-circle cursor-help"></i>
            }
          </label>
          <p-inputgroup>
            <p-select [class.pointer-events-none]="isAnnulus" [class.opacity-50]="isAnnulus" [disabled]="isReadOnly" [options]="pressureLocations"
              [formControlName]="form.formControlNames.pressureLocation" optionLabel="name" optionValue="value"
              appendTo="body"></p-select>
            <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.wellheadPressure" />
            <p-inputgroup-addon>{{ pressureUnit }}</p-inputgroup-addon>
          </p-inputgroup>
          @if (form.formGroup.controls.wellheadPressure.value && form.formGroup.controls.wellheadPressure.invalid) {
            <p class="validation-error">Allowed range: {{ pressureValidation.min }} - {{ pressureValidation.max }} {{ pressureUnit }}</p>
          }
        </div>

        @if (isSubsea && currentTubularIndex > 0 && isInside) {
        <div class="pt-3 pb-3">
          <p-checkbox
              size="small"
              [formControlName]="form.formControlNames.includeRiser"
              inputId="includeRiser"
              binary="true"
              (onChange)="hasRiserChange();"
            ></p-checkbox>
            <label class="pl-2" for="includeRiser">Include Riser</label>
        </div>
        }
      </p-tabpanel>

      <p-tabpanel value="1">
        <p class="{{ landingStringMissing ? 'validation-error' : '' }}">{{ selectedLandingString }}</p>
      </p-tabpanel>

      <p-tabpanel value="2">
        <p-fieldset legend="Riser">
          <div class="space-y-2">
            <div class="flex flex-col">
              <label for="outsideDiameter">Outside Diameter</label>
              <p-inputgroup>
                <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.outsideDiameter" />
                <p-inputgroup-addon>{{ shortLengthUnit }}</p-inputgroup-addon>
              </p-inputgroup>
            </div>

            <div class="flex flex-col">
              <label for="insideDiameter">Inside Diameter</label>
              <p-inputgroup>
                <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.insideDiameter" />
                <p-inputgroup-addon>{{ shortLengthUnit }}</p-inputgroup-addon>
              </p-inputgroup>
            </div>
          </div>
        </p-fieldset>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

</form>